import { MdAutoAwesome, MdFormatQuote } from "react-icons/md";
import Badge from "components/badge";
import Card, { CardHeader } from "components/card";
import { EmptyState } from "components/states";

const StoriesHighlights = ({ summary }) => {
  if (!summary) return null;

  const stories = summary.storyHighlights || [];

  return (
    <Card padding="md">
      <CardHeader
        title="Stories & Highlights"
        actions={
          <Badge tone="brand">
            <MdAutoAwesome aria-hidden="true" className="h-3 w-3" />
            {stories.length} shared
          </Badge>
        }
      />
      {stories.length > 0 ? (
        <ul className="mt-4 space-y-3">
          {stories.map((story, index) => (
            <li
              key={index}
              className="flex items-start gap-3 rounded-control bg-surface-subtle p-3"
            >
              <MdFormatQuote aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-accent" />
              <p className="text-sm italic text-fg">&ldquo;{story}&rdquo;</p>
            </li>
          ))}
        </ul>
      ) : (
        <EmptyState variant="inline" title="No stories shared this week" />
      )}
    </Card>
  );
};

export default StoriesHighlights;
